(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cleanse-faq"]) return;
  try {
    
$(document).ready(function(){
  $('.question').click(function(){
    this.classList.toggle('active');
    this.nextElementSibling.classList.toggle('active');
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"]) return;
  try {
    
$(document).ready(function(){
  $('.question').click(function(){
    this.classList.toggle('active');
    this.nextElementSibling.classList.toggle('active');
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["index-faq"]) return;
  try {
    
$(document).ready(function(){
  $('.question').click(function(){
    this.classList.toggle('active');
    this.nextElementSibling.classList.toggle('active');
  });
});

  } catch(e) { console.error(e); }
})();
})();
